export default __webpack_public_path__ + "static/media/CarelLogo.510685c7.svg";